import { Alert, Button, ButtonGroup } from '@chakra-ui/react'
import { VAT_RATE_ALERT_COPY, type VatRateCategory } from './useVatRateAlert'

type Props = {
  category: VatRateCategory
  onDismiss: () => void
  onOpenInvoiceTexts: () => void
}

/** The Steuerdaten info alert for the current VAT rate case (SIB-1029). */
export function VatRateAlert({ category, onDismiss, onOpenInvoiceTexts }: Props) {
  const copy = VAT_RATE_ALERT_COPY[category]

  return (
    <Alert.Root status="warning" colorPalette="yellow" data-testid={`vat-rate-alert-${category}`}>
      <Alert.Indicator />
      <Alert.Content gap={3}>
        <Alert.Title>{copy.title}</Alert.Title>
        <Alert.Description>{copy.description}</Alert.Description>
        <ButtonGroup colorPalette="yellow" flexWrap="wrap">
          <Button type="button" variant="solid" onClick={onDismiss}>
            Verstanden
          </Button>
          <Button type="button" variant="outline" onClick={onOpenInvoiceTexts}>
            Rechnungstexte
          </Button>
        </ButtonGroup>
      </Alert.Content>
    </Alert.Root>
  )
}
